import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  typography: {
    fontWeight: theme.typography.fontWeightBold,
  },
}));
